/**
 * Client environment helper for feedback reports
 */

export interface ClientEnvironmentInfo {
  browser: string;
  os: string;
  device: string;
  screenResolution: string;
  userAgent: string;
  timezone: string;
  language: string;
}

export const getClientEnvironmentInfo = (): ClientEnvironmentInfo => {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";

  // Browser detection
  let browser = "Unknown";
  if (/Edg\/([0-9.]+)/i.test(ua)) {
    const match = ua.match(/Edg\/([0-9.]+)/i);
    browser = `Edge ${match ? match[1] : ""}`;
  } else if (/OPR\/([0-9.]+)/i.test(ua) || /Opera/i.test(ua)) {
    const match = ua.match(/OPR\/([0-9.]+)/i);
    browser = `Opera ${match ? match[1] : ""}`;
  } else if (/Chrome\/([0-9.]+)/i.test(ua)) {
    const match = ua.match(/Chrome\/([0-9.]+)/i);
    browser = `Chrome ${match ? match[1] : ""}`;
  } else if (/Firefox\/([0-9.]+)/i.test(ua)) {
    const match = ua.match(/Firefox\/([0-9.]+)/i);
    browser = `Firefox ${match ? match[1] : ""}`;
  } else if (/Safari\/([0-9.]+)/i.test(ua) && !/Chrome/i.test(ua)) {
    const match = ua.match(/Version\/([0-9.]+)/i);
    browser = `Safari ${match ? match[1] : ""}`;
  }

  // OS detection
  let os = "Unknown";
  if (/Windows NT 10.0/i.test(ua)) os = "Windows 10/11";
  else if (/Windows NT 6.3/i.test(ua)) os = "Windows 8.1";
  else if (/Windows NT 6.2/i.test(ua)) os = "Windows 8";
  else if (/Windows NT 6.1/i.test(ua)) os = "Windows 7";
  else if (/Mac OS X ([0-9._]+)/i.test(ua)) {
    const match = ua.match(/Mac OS X ([0-9._]+)/i);
    os = `macOS ${match ? match[1].replace(/_/g, ".") : ""}`;
  } else if (/Android ([0-9.]+)/i.test(ua)) {
    const match = ua.match(/Android ([0-9.]+)/i);
    os = `Android ${match ? match[1] : ""}`;
  } else if (/iPhone|iPad|iPod/i.test(ua)) {
    os = "iOS";
  } else if (/Linux/i.test(ua)) {
    os = "Linux";
  }

  // Device detection
  let device = "Desktop";
  const isTouchMac =
    typeof navigator !== "undefined" &&
    navigator.maxTouchPoints > 1 &&
    /Macintosh/.test(ua);
  if (/iPad|Tablet/i.test(ua) || isTouchMac) {
    device = "Tablet";
  } else if (/Mobi|Android|iPhone|iPod/i.test(ua)) {
    device = "Mobile";
  }

  // Screen resolution
  let screenResolution = "";
  if (typeof window !== "undefined") {
    screenResolution = `${window.screen.width}x${window.screen.height} (Viewport: ${window.innerWidth}x${window.innerHeight})`;
  }

  // Timezone
  let timezone = "";
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    // Ignore fallback to empty string
  }

  // Language
  const language = typeof navigator !== "undefined" ? navigator.language : "en";

  return {
    browser: browser.trim(),
    os: os.trim(),
    device,
    screenResolution,
    userAgent: ua,
    timezone,
    language,
  };
};

export const openFeedbackModal = (prefillType?: string): void => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("open-feedback-modal", {
        detail: { type: prefillType },
      }),
    );
  }
};
